import { IDocumentsUploadApplicationState, ISimpleDocument } from '../../../types/order/documents/upload/interfaces';
import { IUploadDocumentAction } from './actions';

export const DocumentUploadReducer = (
  oldState: IDocumentsUploadApplicationState,
  action: IUploadDocumentAction
): IDocumentsUploadApplicationState => {
  switch (action.type) {
    case 'SetUploadIsLoading':
      return { ...oldState, isLoading: action.payload };
    case 'SetUploadIsComplete':
      return { ...oldState, isComplete: action.payload };
    case 'SetUploadHasError':
      return { ...oldState, hasError: action.payload };
    case 'SetUploadDocuments':
      return { ...oldState, documents: action.payload };
    case 'SetUploadDocument':
      return {
        ...oldState,
        documents: oldState.documents.map((sd) => (sd.id === action.payload.id ? action.payload : sd)),
      };
    case 'SetUploadDocumentCategory':
      return {
        ...oldState,
        documents: oldState.documents.map((sd) =>
          sd.id === action.payload.id
            ? ({
                ...sd,
                category: action.payload.category.name,
                versioned: !action.payload.category.isRepeatable,
              } as ISimpleDocument)
            : sd
        ),
      };
    case 'DeleteUploadDocument':
      return {
        ...oldState,
        documents: oldState.documents.filter((d) => d.id !== action.payload),
      };
    case 'SetUploadDocumentMetadata':
      return {
        ...oldState,
        documents: oldState.documents.map((sd) =>
          sd.id === action.payload.id ? ({ ...sd, ...action.payload } as ISimpleDocument) : sd
        ),
      };
  }
};
